import { Component, Lifecycle, Data } from "vuety";
import { IProductGroupItem } from "../../interfaces";
import { getRoot } from "../../root";
import { BaseView } from "../base";
import "thumbnail.css";
import Vue from "vue";

const templateElement = "v-tmpl-groupthumbnail";

@Component({
	template: document.getElementById(templateElement)
		? "#" + templateElement
		: require("./thumbnail.html"),
	mixins: [BaseView],
})
export class ThumbnailView extends Vue {
	@Data
	public currentFullDesc: string;
	@Lifecycle()
	mounted() {
		window.ProductGroupsPlugin.stayOnPage = this.options.stayOnPage;
		window.ProductGroupsPlugin.spaNavigate = true;
		if (document.title && document.title.indexOf("[Product Groups]") > -1) {
			window.ProductGroupsPlugin.pageTitleTemplate = document.title;
		}

		this.$watch(
			"group",
			() => {
				if (this.group != null) {
					this.loadGroupFullDesc();
				}
			},
			{ immediate: true }
		);
	}
	public get groups(): IProductGroupItem[] {
		if (this.options.showXThumbnails) {
			let originalThumbnails = getRoot().currentGroupChildren(this.options);
			let partialThumbnails = originalThumbnails.slice(
				0,
				this.options.showXThumbnails
			);
			return partialThumbnails;
		} else {
			return getRoot().currentGroupChildren(this.options);
		}
	}
	public get group(): IProductGroupItem {
		return getRoot().currentGroupObject(this.options);
	}
	public get groupDesc(): string {
		return getRoot().currentGroupObject(this.options).GroupDesc;
	}

	public loadGroupFullDesc() {
		this.currentFullDesc = "";
		if (getRoot().currentGroupObject(this.options).GroupCode) {
			$.getJSON(
				this.options.ajaxUrl +
					"&getFullDescription=" +
					getRoot().currentGroupObject(this.options).GroupCode
			).done((data: string | any) => {
				let descData;
				if (typeof data === "string") {
					descData = { Description: data };
				} else {
					descData = data;
				}
				this.currentFullDesc = descData.Description || "";
				if (descData.MetaDesc) {
					const descElement = document.querySelector(
						`meta[name="description"]`
					);
					if (descElement) {
						descElement.setAttribute("content", descData.MetaDesc);
					}
				}
			});
		}
	}

	public eachDescription(item: IProductGroupItem) {
		if (this.options.showEachDescription) {
			return item.GroupDesc;
		} else {
			return "";
		}
	}

	public getSubCategories(item: IProductGroupItem) {
		return item.Children;
	}

	public get listThumbnails(): IProductGroupItem[] | null {
		if (this.options.showXThumbnails) {
			return getRoot()
				.currentGroupChildren(this.options)
				.slice(
					this.options.showXThumbnails,
					getRoot().currentGroupChildren(this.options).length
				);
		} else {
			return null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/thumbnail/thumbnail.ts